import React, {useEffect, useRef, useState} from 'react';
import {Dialog} from "primereact/dialog";
import {useTranslate} from "../../../system/useTranslate";
import {Button} from "primereact/button";
import Icon from "../../../system/components/icon";
import {useSelector} from "react-redux";
import InputLabel from "../../../system/components/input-label";
import SelectMember from "../../tasks/components/select-member";
import {Dropdown} from "primereact/dropdown";
import {DataView} from "primereact/dataview";
import {Avatar as PrimeAvatar} from "primereact/avatar";
import PrimeDatePicker from "../../../system/components/prime-date-picker";
import {OverlayPanel} from "primereact/overlaypanel";
import SelectCycle from "./select-cycle";
import DatatableEmptyMessage from "../../../system/components/datatable-empty-message";
import Can from "../../../system/can";
import ArchiveEntityControl from "../../../system/components/archive-entity-control";
import GoalProgressSettings from "../progress/goal-progress-settings";
import {SOURCES as PROGRESS_SOURCES} from "../progress/goal-progress-labels";
import {goalProgressApi} from "../../../models/goal/goal-progress-api";

function GoalSettingsDialog({setVisible, visible, goalData, onSubmit, onArchive}) {

    const translate = useTranslate();
    const [newGoalData, setNewGoalData] = useState();
    const {workspaceMembershipData} = useSelector((state) => state.app);
    useEffect(() => {
        if (visible) {
            // console.log(goalData)
            setNewGoalData(undefined)
        }
    }, [visible]);

    return (
        <Dialog pt={{
            footer: () => ({className: "p-0 border-round-bottom-2xl"}),
            content: () => ({className: "p-0 h-full"})
        }} header={<Header goalData={goalData}/>} contentClassName="p-4"
                headerClassName="border-round-top-2xl border-bottom-1 border-300 pb-3 pt-3"
                footer={<Footer setVisible={setVisible} onSubmit={() => {
                    let _newGoalData = {...newGoalData};
                    if (_newGoalData?.owner) _newGoalData = {..._newGoalData, owner: _newGoalData?.owner?.id};
                    if (_newGoalData?.team) _newGoalData = {..._newGoalData, team: _newGoalData?.team?.id};
                    onSubmit?.({value: _newGoalData})
                }}/>} className="rtl w-6 border-round-bottom-2xl" visible={visible} onHide={() => {
            setVisible(false)
        }}>
            <div className="flex flex-column gap-3">
                <InputLabel require inputType="TEXT" label={translate("project-name")}
                            value={newGoalData?.title === undefined ? goalData?.title : newGoalData?.title}
                            onChange={(e) => {
                                setNewGoalData({...newGoalData, title: e.target.value})
                            }}/>
                <div className="flex align-items-center gap-2 ">
                    <InputLabel className="w-6" label={translate("goal-owner")}>
                        <div className="w-full border-1 border-300 border-round flex align-items-center px-2"
                             style={{minHeight: "42px"}}>
                            <SelectMember primeDropdown={true} selectedMember={newGoalData?.owner || goalData?.owner}
                                          onChange={(membership) => {
                                              setNewGoalData({...newGoalData, owner: membership})
                                          }} hideLabel={false}
                                          members={workspaceMembershipData?.workspace?.workspace_memberships || []}/>
                        </div>
                    </InputLabel>
                    <InputLabel className="w-6" label={translate("responsible-team")}>
                        <SelectTeam options={workspaceMembershipData?.workspace?.teams} value={newGoalData?.team || goalData?.team} onChange={(e) => {setNewGoalData({...newGoalData, team: e})}}/>
                    </InputLabel>
                </div>
                <InputLabel label={translate("progress-source")}>
                    <ProgressSourceButton goalData={goalData}/>
                </InputLabel>
                <InputLabel info={translate("goal-description-info")} onChange={(e) => {
                    setNewGoalData({...newGoalData, description: e.target.value})
                }} className="text-xs" label={translate("goal-description")}
                            value={newGoalData?.description === undefined ? goalData?.description : newGoalData?.description}
                            placeholder={translate("goal-description")} inputType="RICHTEXT"/>
                <div className="surface-50 border-200 border-1 border-round flex p-4 gap-4">
                    <InputLabel className="flex-1" label={translate("dueDate")}>
                        <PrimeDatePicker inputClassName="w-full"
                                         value={new Date(newGoalData?.dueDate || goalData?.dueDate).getTime() / 1000}
                                         onChange={(e) => {
                                             setNewGoalData({...newGoalData, dueDate: new Date(e.value * 1000)})
                                         }}/>
                    </InputLabel>
                    <InputLabel className="flex-1" label={translate("season")}>
                        <SelectCyclePopup value={newGoalData?.cycle || goalData?.cycle} onChange={(e) => {
                            setNewGoalData({...newGoalData, cycle: e})
                        }}/>
                    </InputLabel>
                </div>
                {goalData && (
                    <Can permission="create-new-goals">
                        <ArchiveEntityControl
                            entityName={goalData?.title}
                            sectionTitle={translate("manage-goal")}
                            title={translate("archive-goal-title")}
                            description={translate("archive-goal-description")}
                            buttonLabel={translate("archive-goal")}
                            dialogTitle={translate("archive-goal-confirm-title")}
                            onArchive={onArchive}
                        />
                    </Can>
                )}
            </div>
        </Dialog>
    );
}

function SelectTeam({value, options, onChange}) {
    const translate = useTranslate();

    let _options = [{name: translate("select-team"), id: 0}, ...options];

    const ItemTemplate = (data) => {
        return (
            <div>
                {translate(data?.name)}
            </div>
        )
    }

    return (
        <Dropdown className="w-full" options={_options} value={value || _options[0]}
                  pt={{root: () => ({style: {minHeight: "42px"}})}} valueTemplate={ItemTemplate}
                  onChange={(e) => {
                      onChange?.(e.value)
                  }} itemTemplate={ItemTemplate}/>
    )
}

function SelectCyclePopup({value, onChange}) {
    const translate = useTranslate()
    const ref = useRef();
    return (
        <div>
            <Button className="w-full p-button-outlined p-button-secondary border-300 bg-white"
                    label={value ? `${translate(value?.range)} ${value?.year}` : "---"} onClick={(e) => {
                ref.current.toggle(e)
            }}/>
            <OverlayPanel pt={{root: () => ({className: "p-0 rtl"}), content: () => ({className: "p-0"})}} ref={ref}>
                <SelectCycle value={value} onChange={(e) => {
                    onChange?.(e);
                }} onHide={() => {
                    ref.current.hide()
                }}/>
            </OverlayPanel>
        </div>


        // <Dropdown options={options} value={value} onChange={onChange}/>
    )
}

// «منبع پیشرفت»: opens «تنظیمات پیشرفت هدف» (docs/tasks/28-goal-progress-source.md)
function ProgressSourceButton({goalData}) {
    const [progress, setProgress] = useState(null);
    const [open, setOpen] = useState(false);
    const goalKey = goalData?.documentId;
    useEffect(() => {
        if (!goalKey) return;
        goalProgressApi.get(goalKey).then(setProgress).catch(() => setProgress(null));
    }, [goalKey]);
    const source = PROGRESS_SOURCES.find((item) => item.value === progress?.settings?.source);
    return (
        <div className="flex align-items-center justify-content-between gap-2 w-full surface-50 border-1 border-200 border-round-xl p-3">
            <div className="flex flex-column gap-1">
                <b className="text-xs">{source ? source.label : "تعیین نشده"}</b>
                <span className="text-2xs text-500">{source ? source.text : "پیشرفت از به‌روزرسانی‌های هدف می‌آید؛ منبع را انتخاب کنید تا خودکار یا با مقدار دستی سنجیده شود."}</span>
            </div>
            <Button type="button" className="text-xs p-2 p-button-outlined" icon={<Icon icon="mi mi:tune" className="text-sm pl-2"/>} label="تنظیمات منبع پیشرفت" disabled={!progress?.canManage} onClick={() => setOpen(true)}/>
            <GoalProgressSettings visible={open} onHide={() => setOpen(false)} goal={goalKey} progress={progress} onSaved={setProgress}/>
        </div>
    );
}

// eslint-disable-next-line no-unused-vars
function SelectProgressSource({value, onSelected}) {
    const translate = useTranslate();

    const options = [
        {
            label: "milestone",
            value: "milestone",
            data: {
                icon: "mi mi:flag",
                className: value === "milestone" && "border-2 border-red-500 bg-red-50",
                iconClassName: "bg-red-100 text-red-500"
            }
        },
        {
            label: "subtasks",
            value: "subtasks",
            data: {
                icon: "mi mi:account_tree",
                className: value === "subtasks" && "border-2 border-green-500 bg-green-50",
                iconClassName: "bg-green-100 text-green-500"
            }
        },
        {
            label: "auto",
            value: "auto",
            data: {
                icon: "mi mi:bolt",
                className: value === "auto" && "border-2 border-blue-500 bg-blue-50",
                iconClassName: "bg-blue-100 text-blue-500"
            }
        },
    ]

    const ItemTemplate = (data) => {
        return (
            <div className="p-2 lg:flex-1 md:w-6 w-full text-xs">
                <CardView onClick={() => {
                    onSelected?.(data)
                }}
                          className={`flex flex-column align-items-center justify-content-center gap-2 p-3 ${data?.data.className}`}>
                    <PrimeAvatar shape="circle" size="large" className={data?.data.iconClassName}
                                 icon={<Icon icon={data?.data.icon}/>}/>
                    <span>{translate(data?.label)}</span>
                </CardView>
            </div>
        )
    }
    return (
        <DataView emptyMessage={<DatatableEmptyMessage/>} value={options} layout="grid" itemTemplate={ItemTemplate}/>
    )
}

function CardView({children, className, onClick}) {
    return (
        <div onClick={onClick}
             className={`${className} h-full text-xs w-full shadow-1 border-round-xl ${onClick && "cursor-pointer hover:surface-50"}`}>
            {children}
        </div>
    )
}

function Header({goalData}) {
    const translate = useTranslate();
    return (
        <div className="flex flex-column">
            <span className="text-lg">{translate("goal-settings")}</span>
            <span className="text-xs text-400">{goalData?.title}</span>
        </div>
    )
}

function Footer({setVisible, onSubmit}) {
    const translate = useTranslate();
    return (
        <div
            className="flex flex-row-reverse align-items-center gap-2 justify-content-start p-3 surface-50 border-round-bottom-2xl border-top-1 border-300">
            <Button icon={<Icon icon="mi mi:save" className="text-lg"/>}
                    className="text-xs flex gap-2 border-round-lg p-2" label={translate("save-changes")}
                    onClick={onSubmit}/>
            <Button className="text-xs p-button-secondary p-button-outlined border-round-lg p-2"
                    label={translate("cancel")} onClick={() => {
                setVisible(false)
            }}/>
        </div>
    )
}

export default GoalSettingsDialog;
